import { gql } from "@apollo/client"; // saveVisitaParenteral.js


const SAVE_VISITA_HE = gql`
  mutation saveVisitaHe($input: AddVisitaHeInput!) {
    saveVisitaHe(input: $input) {
      idVisita
      idVisitaHe
    }
  }
`;

export default SAVE_VISITA_HE;

export const adaptAddVisitaHeInput = (data) => ({
  idVisitaHe: data?.idVisitaHe,
  idComboRIValorSellado: data?.idComboRIValorSellado,
  indicacionComentario: data?.indicacionComentario,
  complicaciones: data?.complicaciones,
  idVisita: data?.idVisita
});